/** Approx. glyph width for `text-base` (16px) — enough for prices like «15 000 руб». */
const CHAR_PX = 9;
/** Horizontal cell padding floor (`px-4` × 2). */
const CELL_PADDING_PX = 32;
/** Absolute floor so short headers («Цены») still leave room for values. */
const MIN_FIRST_COLUMN_PX = 160;
const MIN_VALUE_COLUMN_PX = 128;
/** Cap so a long first-column label does not force endless scroll. */
const MAX_FIRST_COLUMN_PX = 280;
const MAX_VALUE_COLUMN_PX = 360;

function getTableColumnCount(rows: string[][]): number {
  if (rows.length === 0) {
    return 0;
  }

  return Math.max(...rows.map((row) => row.length));
}

function getCellCharLength(value: string): number {
  const trimmed = value.trim();
  if (!trimmed) {
    return 0;
  }

  return trimmed.length;
}

/**
 * Content-based min widths (px) so narrow headers do not squeeze values
 * (e.g. «Цены» → «15 000 руб» wrapping mid-number). Table stays scrollable.
 */
export function getSharedTableColumnMinWidths(tables: string[][][]): number[] {
  const columnCount = Math.max(0, ...tables.map(getTableColumnCount));
  if (columnCount === 0) {
    return [];
  }

  const maxLengths = Array.from({ length: columnCount }, () => 0);

  for (const rows of tables) {
    for (const row of rows) {
      for (let columnIndex = 0; columnIndex < columnCount; columnIndex += 1) {
        maxLengths[columnIndex] = Math.max(
          maxLengths[columnIndex],
          getCellCharLength(row[columnIndex] ?? "")
        );
      }
    }
  }

  return maxLengths.map((length, columnIndex) => {
    const contentWidth = length * CHAR_PX + CELL_PADDING_PX;
    const isFirst = columnIndex === 0;
    const floor = isFirst ? MIN_FIRST_COLUMN_PX : MIN_VALUE_COLUMN_PX;
    const cap = isFirst ? MAX_FIRST_COLUMN_PX : MAX_VALUE_COLUMN_PX;

    return Math.min(Math.max(contentWidth, floor), cap);
  });
}
